import { render, staticRenderFns } from "./email-verification-login.vue?vue&type=template&id=921c208a&scoped=true&"
import script from "./email-verification-login.vue?vue&type=script&lang=js&"
export * from "./email-verification-login.vue?vue&type=script&lang=js&"
import style0 from "./email-verification-login.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./email-verification-login.vue?vue&type=style&index=1&id=921c208a&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "921c208a",
  null
  
)

export default component.exports